import React, { useState } from 'react';
import { 
  ChevronRight, 
  Search, 
  FileText, 
  Download, 
  Printer,
  Calendar,
  GraduationCap,
  Award,
  CheckCircle,
  XCircle,
  Loader,
  Filter,
  BookOpen,
  Users,
  TrendingUp,
  ExternalLink
} from 'lucide-react';

const ResultSection = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchType, setSearchType] = useState('rollno');
  const [isSearching, setIsSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [selectedExam, setSelectedExam] = useState('all');

  const sampleResult = {
    name: "RAHUL KUMAR",
    rollNo: "RDS2024001",
    fatherName: "RAJESH KUMAR",
    motherName: "SUNITA DEVI",
    course: "BCA",
    semester: "4th Semester",
    examYear: "2024",
    status: "PASS",
    percentage: "78.5%",
    cgpa: "7.85",
    subjects: [
      { name: "Programming in Java", code: "BCA401", theory: 68, practical: 25, total: 93, status: "PASS" },
      { name: "Database Management", code: "BCA402", theory: 72, practical: 22, total: 94, status: "PASS" },
      { name: "Computer Networks", code: "BCA403", theory: 65, practical: 24, total: 89, status: "PASS" },
      { name: "Web Technologies", code: "BCA404", theory: 70, practical: 26, total: 96, status: "PASS" },
      { name: "Mathematics", code: "BCA405", theory: 58, practical: 20, total: 78, status: "PASS" }
    ],
    totalMarks: 450,
    obtainedMarks: 353,
    resultDate: "15 March 2024"
  };

  const recentResults = [
    { id: 1, title: "BCA 4th Sem Result 2024", date: "15 Mar 2024", type: "Even Semester" },
    { id: 2, title: "MBA 2nd Sem Result 2024", date: "10 Mar 2024", type: "Even Semester" },
    { id: 3, title: "BBA 6th Sem Result 2024", date: "05 Mar 2024", type: "Final Year" },
    { id: 4, title: "MCA 2nd Sem Result 2024", date: "28 Feb 2024", type: "Even Semester" },
    { id: 5, title: "BCA 2nd Sem Result 2024", date: "20 Feb 2024", type: "Even Semester" },
  ];

  const examFilters = [
    "All Results",
    "BCA",
    "MCA",
    "BBA",
    "MBA",
    "Diploma"
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    setIsSearching(true);
    
    setTimeout(() => {
      setIsSearching(false);
      setShowResults(true);
    }, 1500);
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    alert("Downloading result...");
  };

  return (
    <div className="bg-white min-h-screen">
      <div className="relative bg-gradient-to-r from-blue-900 to-blue-800 text-white py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-orange-500 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-blue-400 rounded-full blur-3xl"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm text-blue-200 mb-4">
            <span className="hover:text-orange-400 cursor-pointer">Home</span>
            <ChevronRight size={16} />
            <span className="text-orange-400 font-semibold">Result</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Student Results</h1>
          <p className="text-xl text-blue-100 max-w-2xl">Access your semester examination results instantly</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-2xl shadow-xl p-6 text-center transform hover:scale-105 transition-all duration-300">
            <div className="inline-flex p-3 bg-green-100 rounded-full mb-3">
              <Users className="w-6 h-6 text-green-600" />
            </div>
            <div className="text-2xl md:text-3xl font-bold text-blue-900">1348</div>
            <div className="text-sm text-gray-600">Records Found</div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6 text-center transform hover:scale-105 transition-all duration-300">
            <div className="inline-flex p-3 bg-blue-100 rounded-full mb-3">
              <GraduationCap className="w-6 h-6 text-blue-600" />
            </div>
            <div className="text-2xl md:text-3xl font-bold text-blue-900">15+</div>
            <div className="text-sm text-gray-600">Courses</div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6 text-center transform hover:scale-105 transition-all duration-300">
            <div className="inline-flex p-3 bg-orange-100 rounded-full mb-3">
              <Award className="w-6 h-6 text-orange-600" />
            </div>
            <div className="text-2xl md:text-3xl font-bold text-blue-900">92%</div>
            <div className="text-sm text-gray-600">Pass Percentage</div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6 text-center transform hover:scale-105 transition-all duration-300">
            <div className="inline-flex p-3 bg-purple-100 rounded-full mb-3">
              <TrendingUp className="w-6 h-6 text-purple-600" />
            </div>
            <div className="text-2xl md:text-3xl font-bold text-blue-900">2024</div>
            <div className="text-sm text-gray-600">Current Year</div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-3xl p-8 mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-blue-900 mb-8">Check Your Result</h2>
            <div className="flex justify-center space-x-4 mb-8">
            <button
              onClick={() => setSearchType('rollno')}
              className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 ${
                searchType === 'rollno'
                  ? 'bg-orange-500 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Roll Number
            </button>
            <button
              onClick={() => setSearchType('name')}
              className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 ${
                searchType === 'name'
                  ? 'bg-orange-500 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Student Name
            </button>
          </div>

          <form onSubmit={handleSearch} className="max-w-2xl mx-auto">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1 relative">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder={searchType === 'rollno' ? "Enter Roll Number (e.g., RDS2024001)" : "Enter Exact Name..."}
                  className="w-full px-6 py-4 rounded-full border-2 border-gray-200 focus:border-orange-500 focus:outline-none text-gray-700"
                  required
                />
                <Filter className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              </div>
              <button
                type="submit"
                disabled={isSearching}
                className="bg-orange-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-orange-600 transition-colors duration-300 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSearching ? (
                  <>
                    <Loader className="w-5 h-5 animate-spin" />
                    <span>Searching...</span>
                  </>
                ) : (
                  <>
                    <Search className="w-5 h-5" />
                    <span>Search Result</span>
                  </>
                )}
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-4 text-center">
              Database Ready: <span className="font-semibold text-green-600">1348 records found</span>
            </p>
          </form>
        </div>
        {showResults && (
          <div className="mb-12 animate-fadeIn">
            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
              <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white p-6">
                <div className="flex flex-col md:flex-row justify-between items-center">
                  <div>
                    <h3 className="text-2xl font-bold mb-2">Examination Result</h3>
                    <p className="text-blue-200">{sampleResult.course} - {sampleResult.semester} ({sampleResult.examYear})</p>
                  </div>
                  <div className="flex space-x-3 mt-4 md:mt-0">
                    <button 
                      onClick={handlePrint}
                      className="bg-white/20 hover:bg-white/30 p-2 rounded-lg transition-colors duration-300"
                      title="Print Result"
                    >
                      <Printer className="w-5 h-5" />
                    </button>
                    <button 
                      onClick={handleDownload}
                      className="bg-white/20 hover:bg-white/30 p-2 rounded-lg transition-colors duration-300"
                      title="Download Result"
                    >
                      <Download className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-gray-50 border-b border-gray-200">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Student Name</p>
                    <p className="font-semibold text-blue-900">{sampleResult.name}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Roll Number</p>
                    <p className="font-semibold text-blue-900">{sampleResult.rollNo}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Father's Name</p>
                    <p className="font-semibold text-blue-900">{sampleResult.fatherName}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Mother's Name</p>
                    <p className="font-semibold text-blue-900">{sampleResult.motherName}</p>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">Subject Code</th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">Subject Name</th>
                      <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Theory</th>
                      <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Practical</th>
                      <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Total</th>
                      <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sampleResult.subjects.map((subject, index) => (
                      <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="px-4 py-3 text-sm text-gray-700">{subject.code}</td>
                        <td className="px-4 py-3 text-sm text-gray-700">{subject.name}</td>
                        <td className="px-4 py-3 text-sm text-center text-gray-700">{subject.theory}</td>
                        <td className="px-4 py-3 text-sm text-center text-gray-700">{subject.practical}</td>
                        <td className="px-4 py-3 text-sm text-center font-semibold text-gray-700">{subject.total}</td>
                        <td className="px-4 py-3 text-sm text-center">
                          <span className="inline-flex items-center space-x-1 text-green-600">
                            <CheckCircle className="w-4 h-4" />
                            <span>PASS</span>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="p-6 bg-gray-50 border-t border-gray-200">
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Total Marks</p>
                    <p className="text-xl font-bold text-blue-900">{sampleResult.totalMarks}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Obtained</p>
                    <p className="text-xl font-bold text-blue-900">{sampleResult.obtainedMarks}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Percentage</p>
                    <p className="text-xl font-bold text-green-600">{sampleResult.percentage}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">CGPA</p>
                    <p className="text-xl font-bold text-orange-500">{sampleResult.cgpa}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Result</p>
                    <p className="text-xl font-bold text-green-600">{sampleResult.status}</p>
                  </div>
                </div>
                <p className="text-xs text-gray-400 mt-4">Result Date: {sampleResult.resultDate}</p>
              </div>
            </div>
          </div>
        )}
        <div className="mt-16">
          <h2 className="text-2xl font-bold text-blue-900 mb-6">Recent Results</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {recentResults.map((result) => (
              <div key={result.id} className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-all duration-300 border border-gray-100">
                <div className="flex items-start justify-between mb-3">
                  <FileText className="w-8 h-8 text-orange-500" />
                  <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded-full">
                    {result.type}
                  </span>
                </div>
                <h3 className="font-semibold text-blue-900 mb-2">{result.title}</h3>
                <div className="flex items-center text-sm text-gray-500 mb-4">
                  <Calendar className="w-4 h-4 mr-1" />
                  {result.date}
                </div>
                <button className="text-orange-500 text-sm font-semibold flex items-center space-x-1 hover:space-x-2 transition-all duration-300">
                  <span>View Result</span>
                  <ExternalLink className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-16">
          <h2 className="text-2xl font-bold text-blue-900 mb-6">Browse by Examination</h2>
          <div className="flex flex-wrap gap-3">
            {examFilters.map((filter, index) => (
              <button
                key={index}
                onClick={() => setSelectedExam(filter)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300 ${
                  selectedExam === filter
                    ? 'bg-orange-500 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
          <div className="grid md:grid-cols-3 gap-4 mt-6">
            {[1, 2, 3].map((item) => (
              <div key={item} className="bg-gray-50 rounded-lg p-4 flex items-center justify-between">
                <div>
                  <h4 className="font-semibold text-blue-900">BCA {item}rd Semester</h4>
                  <p className="text-sm text-gray-500">Dec 2023</p>
                </div>
                <button className="text-orange-500 hover:text-orange-600">
                  <Download className="w-5 h-5" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
};

export default ResultSection;